// Woher weiß die App, welches Planner-Board sie zeigt?
//
// Aus der Adresse: `?plan=<Plan-ID>`. Das ist die EINZIGE Quelle – in Teams
// wie im normalen Browser. Die Konfigurationsseite schreibt die gewählte
// Plan-ID beim Einrichten des Tabs in die Inhaltsadresse; danach kennt der
// Tab sein Board dauerhaft, ohne localStorage, ohne Titel-Raten und ohne
// Suche über alle Gruppen (so lief es in der alten App, mit drei Fallbacks
// und einem Tag Fehlersuche, weil /me/memberOf keine Reihenfolge garantiert).
//
// Lesen UND Schreiben der Adresse stehen absichtlich in derselben Datei:
// Wer das Format ändert, sieht beide Seiten.

const PARAMETER = "plan";

export function boardAusAdresse(): string | null {
  const wert = new URLSearchParams(window.location.search).get(PARAMETER);
  return wert && wert.trim() ? wert.trim() : null;
}

export function adresseFuerBoard(planId: string): string {
  const url = new URL("/", window.location.origin);
  url.searchParams.set(PARAMETER, planId);
  return url.toString();
}
